var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLowsetRadiation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 69,
    viewBox: "0 0 106 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_198_23924)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.6776 1.26416H5.2651C4.62655 1.26416 4.01415 1.51783 3.56262 1.96936C3.11109 2.42088 2.85742 3.03328 2.85742 3.67184V41.9395",
    stroke: "black",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.98242 67.4752H42.8034H95.5834",
    stroke: "black",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4541 1.26416V28.3616",
    stroke: "black",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.015 67.4754H27.6176C21.0508 67.4754 14.7529 64.8667 10.1095 60.2233C5.46607 55.5799 2.85742 49.282 2.85742 42.7152C2.85742 39.4637 3.49786 36.2439 4.74218 33.2399C5.98649 30.2359 7.81031 27.5063 10.1095 25.2071C12.4087 22.908 15.1382 21.0841 18.1423 19.8398C21.1463 18.5955 24.366 17.9551 27.6176 17.9551H41.5208C41.9359 17.9551 42.3339 18.12 42.6274 18.4135C42.9209 18.707 43.0858 19.105 43.0858 19.5201V26.7965C43.0858 27.2116 42.9209 27.6097 42.6274 27.9032C42.3339 28.1967 41.9359 28.3615 41.5208 28.3615H28.9917C28.5767 28.3615 28.1786 28.1967 27.8851 27.9032C27.5916 27.6097 27.4267 27.2116 27.4267 26.7965V22.0825",
    stroke: "black",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8853 63.3615H28.1003C22.6246 63.3615 17.3732 61.1863 13.5012 57.3144C9.62932 53.4424 7.4541 48.191 7.4541 42.7153C7.4541 40.004 7.98813 37.3192 9.0257 34.8143C10.0633 32.3094 11.5841 30.0333 13.5012 28.1161C15.4184 26.1989 17.6944 24.6782 20.1994 23.6406C22.7043 22.603 25.3891 22.069 28.1004 22.069H42.8854",
    stroke: "black",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.886 67.0376V58.753C42.886 58.3379 42.7211 57.9399 42.4276 57.6464C42.1341 57.3529 41.736 57.188 41.321 57.188H29.2662C28.8511 57.188 28.453 57.3529 28.1595 57.6464C27.8661 57.9399 27.7012 58.3379 27.7012 58.753V63.3291",
    stroke: "black",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4709 17.9551H61.6212C60.8812 17.9551 60.2812 18.555 60.2812 19.2951V30.6768C60.2812 31.4169 60.8812 32.0168 61.6212 32.0168H82.4709C83.2109 32.0168 83.8109 31.4169 83.8109 30.6768V19.2951C83.8109 18.555 83.2109 17.9551 82.4709 17.9551Z",
    stroke: "black",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0459 17.4613V1.26416",
    stroke: "black",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1761 39.7871H30.4369C29.1676 39.7871 28.1387 40.8161 28.1387 42.0854C28.1387 43.3546 29.1676 44.3836 30.4369 44.3836H91.1761C92.4454 44.3836 93.4744 43.3546 93.4744 42.0854C93.4744 40.8161 92.4454 39.7871 91.1761 39.7871Z",
    stroke: "black",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6644 44.3835H59.3838V67.4754H84.6644V44.3835Z",
    stroke: "black",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5889 20.6652C94.0231 23.0994 94.1695 25.9852 91.5889 28.5658",
    stroke: "#F69A4D",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9404 22.7858C89.9277 23.6864 90.2121 25.9142 88.9404 26.8622",
    stroke: "#F69A4D",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6661 28.5658C50.2319 26.1316 50.0855 23.2458 52.6661 20.6652",
    stroke: "#F69A4D",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3143 26.4453C54.327 25.5447 54.0426 23.3169 55.3143 22.3689",
    stroke: "#F69A4D",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.847 29.2958V13.6774",
    stroke: "black",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.127 27.5662L102.846 28.5352L100.565 27.5662L102.846 32.9732L105.127 27.5662Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_198_23924"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 105,
    height: 69,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowsetRadiation);
export default __webpack_public_path__ + "static/media/lowset_radiation.9b7ffafd4c42ec94669d452fba1de57c.svg";
export { ForwardRef as ReactComponent };